import React, { useEffect, useState, useRef, forwardRef } from "react"
import axios from 'axios'
import '../Dashboard.css'
import '../styles/FmUx.css'
import { getFmSourceLabel } from '../utils/fmSource'

import Select, { StylesConfig } from 'react-select'

import Header from "../components/Header"
import Footer from "../components/Footer"
import ScrollToTop from "../components/ScrollTop"
import PreloadFetch from "../components/PreloadFetch"
import { ToastContainer, toast } from 'react-toastify'

import moment from 'moment'
import momentTZ from 'moment-timezone'
import 'moment/locale/es'
moment.locale('es')

import { ImEye, ImFilePdf, ImSearch, ImCross, ImArrowUpRight2 } from "react-icons/im"
import { useAuth } from '../provider/authProvider'
import { Link, useNavigate } from "react-router-dom"

import ResponsivePagination from 'react-responsive-pagination'
import 'react-responsive-pagination/themes/classic.css'

import PhoneLoader from "../components/loader/PhoneLoader"


import "flatpickr/dist/themes/material_green.css"
import Flatpickr from "flatpickr"
// import "flatpickr/dist/flatpickr.min.css";
import { Spanish } from 'flatpickr/dist/l10n/es.js'

import {
    handleDniInput,
    handleFullNameInput,
    handleLastNameInput,
    handlePhoneInput,
    handleEmailInput,
    handleAddressInput,
    handleImeiInput
} from "../utils/inputUtils";


function FmPage(props) {
    const { user, rol } = useAuth()
    const navigate = useNavigate()

    const searchRef = useRef()

    const [listCredits, setListCredits] = useState()

    const [listPhones, setListPhones] = useState([])
    const [phoneName, setPhoneName] = useState(localStorage.getItem('phoneName') || '')

    const [preload, setPreload] = useState(false)
    let [numPages, setNumPages] = useState(0)
    const [paginationHtml, setPaginationHtml] = useState([])
    const [selectPagination, setSelectPagination] = useState(1)
    const [showPagination, setShowPagination] = useState(true)
    const [selectFilterState, setSelectFilterState] = useState(0)
    // const [filterState, setFilterState] = useState([])
    const [arrCountFilter, setArrCountFilter] = useState([])

    // useStates fmPage
    const [showPopupAdd, setShowPopupAdd] = useState(false)
    const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // ref form fm
    const fullNameRef = useRef()
    const lastNameRef = useRef()
    const dniRef = useRef()
    const emailRef = useRef()
    const addressNameRef = useRef()
    const phoneNumberRef = useRef()
    const sourceRef = useRef()
    const amountSourceRef = useRef()
    const amountFMRef = useRef()
    const numFeeRef = useRef()
    const countFeePayRef = useRef()
    const modelPhoneRef = useRef()
    const imeiRef = useRef()
    const sedeRef = useRef()
    const formFmRef = useRef()
    const feeRef = useRef()

    // DatePicker
    const calendarInputRef = useRef();
    const [startDate, setStartDate] = useState(new Date())

    // images
    const dniFrontRef = useRef()
    const dniBackRef = useRef()
    const [dniFrontData, setDniFrontData] = useState(null)
    const [dniBackData, setDniBackData] = useState(null)

    const [imgPreviewFront, setImgPreviewFront] = useState(null)
    const [imgPreviewBack, setImgPreviewBack] = useState(null)

    // placeholder
    let placeHolderFileImage = 'https://placehold.co/600x400?text='

    const [amountFee, setAmountFee] = useState(0)

    //
    const [source, setSource] = useState('Payjoy')
    const [amountSource, setAmountSource] = useState()

    // frequencia de pago
    const pfRef = useRef()
    const [pf, setPf] = useState(1)
    const paymentFrequency = [
        'Semanal', 'Quincenal'
    ]
    const ordinalsTime = [
        {
            singular: 'Semana',
            plural: 'Semanas'
        },
        {
            singular: 'Quincena',
            plural: 'Quincenas'
        },
        {
            singular: 'Mes',
            plural: 'Meses'
        }
    ]

    // Preloader
    const [loading, setLoading] = useState(false)

    //
    let [countFeePayArr, setCountFeePayArr] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10])

    // 

    const getFM = async () => {
        try {
            setPreload(true)
            const credits = await axios({
                method: 'get',
                url: process.env.REACT_APP_API + '/fms',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    user
                }
            })
            const resData = credits.data
            setListCredits(resData.data)
            setPreload(false)
            setNumPages(resData.numPages)
            setArrCountFilter(resData.arrCountFilter)
        } catch (err) {
            console.log(err)
            return false
        }
    }

    // get phone
    const getPhones = async () => {
        try {
            setPreload(true)
            const credits = await axios({
                method: 'get',
                url: process.env.REACT_APP_API + '/list-phones',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    user
                }
            })
            const resData = credits.data
            if (resData.msg === 'errorRefresh') {
                localStorage.removeItem('token')
                localStorage.removeItem('name')
                localStorage.removeItem('user')
                window.location.reload()
            }
            setListPhones(resData.data)
        } catch (err) {
            console.log(err)
            return false
        }
    }

    const listPhoneChange = (phone) => {
        if (phone && phone.price) {
            setPhoneName(phone.value)
        }
    }

    const followToEnroll = (linkNumber, dni) => {
        localStorage.setItem('linkNumber', linkNumber)
        localStorage.setItem('dniEnroll', dni)
        navigate("/evaluation-system/enroll-phone")
    }

    const getStatedevice = async () => {
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_DEVICE_DETAILS
        let dataID = getParams.id

        const stateDevice = await axios({
            method: 'POST',
            url: pathApi,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                user,
                'Content-Type': 'application/json',
            },
            data: { dataID },
            withCredentials: false,
            credentials: 'include'
        })
        const resData = stateDevice.data
        if (resData.msg == 'exito') {
            setStateDevice(resData.statusLock)
        }
    }

    const getNameDate = (datePass) => {
        const dateSplit = datePass.split(' ')
        const dateSplitOne = dateSplit[0]
        const dateSplitTwo = dateSplit[1]
        const splitDateOne = dateSplitOne.split('-')
        const structureDate = splitDateOne[2] + '-' + splitDateOne[1] + '-' + splitDateOne[0] + ' ' + dateSplitTwo
        const formatDate = structureDate
        const dayNames = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'sábado', 'Domingo']
        let date = ''
        if (splitDateOne[0].length != 4) {
            date = new Date(formatDate)
        } else {
            date = new Date(datePass)
        }
        return dayNames[date.getDay() - 1]
    }

    const searchEngine = async (event) => {
        let searchName = event.target.value
        let idPagination = selectPagination
        if (searchName.length > 0) {
            setShowPagination(false)
        } else {
            setShowPagination(true)
            setSelectFilterState(0)
        }
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_FMS_SEARCH
        const insertCredit = await axios({
            method: 'POST',
            url: pathApi,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                'Content-Type': 'application/json',
            },
            data: { searchName, idPagination },
            withCredentials: false,
            credentials: 'include'
        })
        const resData = insertCredit.data
        if (resData.msg == 'success') {
            setListCredits(resData.data)
        }
    }

    const paginationEngine = () => {
        let html = []
        numPages = 20
        for (let page = 1; page <= numPages; page++) {
            if (page == selectPagination) {
                html.push(<li key={page} onClick={getDataOfPagination} className="select">{page}</li>)
            } else {
                html.push(<li key={page} onClick={getDataOfPagination}>{page}</li>)
            }
        }
        setPaginationHtml(html)
    }

    const getDataOfPagination = async (event) => {
        let idPagination = parseInt(event)
        let filterState = selectFilterState
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_FMS_PAGINATION_DATA
        const insertCredit = await axios({
            method: 'POST',
            url: pathApi,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                'Content-Type': 'application/json',
            },
            data: { idPagination, filterState },
            withCredentials: false,
            credentials: 'include'
        })
        const resData = insertCredit.data
        if (resData.msg == 'success') {
            setListCredits(resData.data)
            setSelectPagination(idPagination)
        }
    }

    const filterChangeFunc = async (state) => {
        let idPagination = 1
        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_FMS_FILTER_DATA
        const insertCredit = await axios({
            method: 'POST',
            url: pathApi,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                'Content-Type': 'application/json',
            },
            data: { idPagination, statusID: state }
        })
        const resData = insertCredit.data
        if (resData.msg == 'success') {
            setSelectPagination(1)
            setListCredits(resData.data)
            setSelectFilterState(state)
            setNumPages(resData.numPages)
        }
    }

    const changeDate = (date) => {
        let firtsPaymentTransformOne = date.split('/')
        let constructDate = firtsPaymentTransformOne[2] + '-' + firtsPaymentTransformOne[1] + '-' + firtsPaymentTransformOne[0]
        return constructDate
    }

    const exportxlsx = async () => {
        return false
    }

    const generateDayName = (date) => {
        try {
            let newDate = date
            if (date) {
                let splitDate = date.split(' ')
                let splitMiddleDash = splitDate[0].split('-')

                if (splitMiddleDash[0].length <= 2) {
                    newDate = splitMiddleDash[2] + '-' + splitMiddleDash[1] + '-' + splitMiddleDash[0] + ' ' + splitDate[1]
                }
            }
            return moment(newDate).format('dddd')
        } catch (e) {
            console.log(e)
        }
    }

    const showPopup = () => {
        setShowPopupAdd(true)
        document.body.style.overflow = 'hidden'
    }

    const sendFmData = async () => {
        const dataObject = {
            source: sourceRef.current.value,
            amountSource: amountSourceRef.current.value,
            fullName: fullNameRef.current.value,
            lastName: lastNameRef.current.value,
            dni: dniRef.current.value,
            phoneNumber: phoneNumberRef.current.value,
            email: emailRef.current.value,
            addressName: addressNameRef.current.value,
            amountFM: amountFMRef.current.value,
            numFee: numFeeRef.current.value,
            fee: feeRef.current.value,
            countFeePay: countFeePayRef.current.value,
            modelPhone: phoneName,
            paymentFrequency: pfRef.current.value,
            imei: imeiRef.current.value,
            dateRegister: moment(startDate).tz("America/Lima").format("YYYY-MM-DD HH:mm:ss"),
            sede: sedeRef.current.value,
            dniFrontFile: dniFrontRef.current,
            dniBackFile: dniBackRef.current
        }

        const dataObjectError = {
            source: 'Error: Ingresar Fuente',
            amountSource: 'Error: Ingresar Cuota Fuente',
            fullName: 'Error: Ingresar Nombre Completo',
            lastName: 'Error: Ingresar Apellidos',
            dni: 'Error: Ingresar DNI',
            phoneNumber: 'Error: Ingresar Número de celular',
            email: 'Error: Ingresar Email',
            addressName: 'Error: Ingresar Dirección',
            amountFM: 'Error: Ingresar Monto FM',
            numFee: 'Error: Ingresar Cuotas FM a Dividir',
            fee: 'Error: Ingresar Cuota FM',
            countFeePay: 'Error: Ingresar Cuotas a Pagar',
            modelPhone: 'Error: Ingresar Nombre de Equipo',
            paymentFrequency: 'Error: Ingresar Frecuencia de pago',
            imei: 'Error: Ingresar IMEI del Equipo',
            dateRegister: 'Error: Ingresar Fecha de Registro',
            sede: 'Error: Ingresar Sede',
        }

        let countError = 0
        let validatorObject = false
        for (const key in dataObject) {
            let value = dataObject[key]
            if (value === null || value === undefined || value === '') {
                alert(Object.values(dataObjectError)[countError])
                validatorObject = true
                break
            }
            countError++
        }

        if (validatorObject == false && dniRef.current.value.length !== 8) {
            validatorObject = true
            alert('Error: Ingresar 8 dígitos en DNI')
        }

        if (validatorObject == false && phoneNumberRef.current.value.length !== 9) {
            validatorObject = true
            alert('Error: Ingresar 9 dígitos en número de celular')
        }

        if (validatorObject == false && !regexEmail.test(dataObject.email)) {
            validatorObject = true
            alert('Error: Ingresar Email Correcto')
        }

        if (validatorObject == false && imeiRef.current.value.length !== 15) {
            validatorObject = true
            alert('Error: Ingresar 15 dígitos en el IMEI')
        }

        if (validatorObject) return false

        const formData = new FormData()
        formData.append('source', dataObject.source)
        formData.append('amountSource', dataObject.amountSource)
        formData.append('fullName', dataObject.fullName)
        formData.append('lastName', dataObject.lastName)
        formData.append('dni', dataObject.dni)
        formData.append('phoneNumber', dataObject.phoneNumber)
        formData.append('email', dataObject.email)
        formData.append('addressName', dataObject.addressName)
        formData.append('amountFM', dataObject.amountFM)
        formData.append('numFee', dataObject.numFee)
        formData.append('fee', dataObject.fee)
        formData.append('countFeePay', dataObject.countFeePay)
        formData.append('modelPhone', dataObject.modelPhone)
        formData.append('paymentFrequency', dataObject.paymentFrequency)
        formData.append('imei', dataObject.imei)
        formData.append('dateRegister', dataObject.dateRegister)
        formData.append('sede', dataObject.sede)
        formData.append('dniFrontFile', dataObject.dniFront)
        formData.append('dniBackFile', dataObject.dniBack)

        let pathApi = process.env.REACT_APP_API + process.env.REACT_APP_UPLOAD_FM_DATA
        setLoading(true)
        try {
            const insertCredit = await axios({
                method: 'POST',
                url: pathApi,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    'Content-Type': 'multipart/form-data',
                },
                data: formData
            })
            const resData = insertCredit.data
            if (resData.msg == 'success') {
                let msg = 'AGREGADO CON ÉXITO'
                toast.success(msg,
                    {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    }
                )

                setShowPopupAdd(false)
                setPhoneName('')
                setStartDate(new Date())
                setImgPreviewFront(null)
                setImgPreviewBack(null)
                setAmountSource()
                setAmountFee()
                setPf(1)
                document.body.style.overflow = 'auto'

                getFM()
            } else {
                let msg = 'NO TIENES PERMISO PARA ESTA ACCIÓN'
                toast.error(msg,
                    {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    }
                )
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const drivePreviewFront = (e) => {
        const archivo = e.target.files[0]
        if (!archivo) return

        dniFrontRef.current = archivo
        setDniFrontData(archivo)

        const lector = new FileReader()
        lector.onload = () => {
            setImgPreviewFront(lector.result)
        }
        lector.readAsDataURL(archivo)
    }

    const drivePreviewBack = (e) => {
        const archivo = e.target.files[0]
        if (!archivo) return

        dniBackRef.current = archivo
        setDniBackData(archivo)

        const lector = new FileReader()
        lector.onload = () => {
            setImgPreviewBack(lector.result)
        }
        lector.readAsDataURL(archivo)
    }

    const calculateFee = () => {
        if (amountFMRef.current.value !== '') {
            let amountFM = parseFloat(amountFMRef.current.value)
            let numFee = parseInt(numFeeRef.current.value)

            let division = amountFM / numFee
            setAmountFee(parseFloat(division).toFixed(2))
        }
    }

    const changeSource = () => {
        let sourceValue = sourceRef.current.value
        setSource(getFmSourceLabel(sourceValue))
    }

    const closeFmPopup = () => {
        setShowPopupAdd(false)
        setPhoneName('')
        setStartDate(new Date())
        setImgPreviewFront(null)
        setImgPreviewBack(null)
        setAmountSource()
        setAmountFee()
        setPf(1)
        document.body.style.overflow = 'auto'
    }

    const doDecimal = (e) => {
        let inputValue = e.target.value
        inputValue = inputValue.replace(/[^0-9.]/gi, "")
        const parts = inputValue.split(".")
        if (parts.length > 2) {
            inputValue = parts[0] + "." + parts[1]
        }
        if (parts.length === 2) {
            parts[1] = parts[1].slice(0, 2)
            inputValue = parts[0] + "." + parts[1]
        }
    }

    const pfChange = () => {
        let value = pfRef.current.value
        setPf(value)

        if (value == 3) setCountFeePayArr([0, 1, 2, 3])
        if (value == 2) setCountFeePayArr([0, 1, 2, 3, 4, 5])
        if (value == 1) setCountFeePayArr([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
    }

    const changeDatef = (date) => {
        if (date) {
            setStartDate(date)
        }
    }

    const formatDate = (date) => {
        return moment(date).format("DD-MM-YYYY");
    };

    useEffect(() => {
        getPhones()
        const filterPhone = listPhones.filter((i) => i.price > 0)
        setListPhones(filterPhone)
        localStorage.removeItem('linkNumber')
        localStorage.removeItem('dniEnroll')
        getFM()
    }, [])

    useEffect(() => {
        paginationEngine()
    }, [numPages, selectPagination, selectFilterState])

    useEffect(() => {
        if (!calendarInputRef.current) return;

        Flatpickr(calendarInputRef.current, {
            locale: Spanish,
            dateFormat: 'd-m-Y',
            position: 'auto center',
            onChange: ([date]) => changeDatef(date),
        });
    }, [showPopupAdd]);

    return (
        <div>
            {
                preload && (
                    <PreloadFetch />
                )
            }
            {
                loading && (
                    <PhoneLoader />
                )
            }
            <ScrollToTop />
            <Header user={user} namePage={props.namePage} />
            <section className="sectionBody sectionBodyCredits sectionBodyFms">
                <div className="containerCustom containerBody">
                    <div className="blockBody">

                        {/* <div className="buttonAddFm" onClick={showPopup}>
                            <button>AGREGAR FM</button>
                        </div> */}

                        <div className="boxSearchEngine fmUxSearch">
                            <div>
                                <ImSearch />
                                <input ref={searchRef} onInput={(event) => searchEngine(event)} type="text" />
                            </div>
                        </div>

                        <div className="ImArrowUpRight2Parent">
                            <Link className="arrowUpRight" to={'../fm-stats'}>
                                <span>Estadisticas</span>
                                <ImArrowUpRight2 />
                            </Link>
                        </div>

                        <div className="fmUxHeader"><div><span className="fmUxEyebrow">Gestión de cartera</span><h3>Financiamientos Mixtos</h3><p>Consulta el estado, vencimientos y fuente financiera de cada FM.</p></div></div>

                        <div className="filterHeader fmUxFilters">
                            <div className="filterOptions ff">

                                {
                                    arrCountFilter && arrCountFilter[1] > 0 && (
                                        <div onClick={() => filterChangeFunc(1)} className={selectFilterState == 1 ? "select filterOptionsItem filterOptionsItem1" : "filterOptionsItem filterOptionsItem1"}>Activos({arrCountFilter[1]})</div>
                                    )
                                }
                                {
                                    arrCountFilter && arrCountFilter[5] > 0 && (
                                        <div onClick={() => filterChangeFunc(5)} className={selectFilterState == 5 ? "select filterOptionsItem filterOptionsItem7" : "filterOptionsItem filterOptionsItem7"}>Vence Mañana({arrCountFilter[5]})</div>
                                    )
                                }
                                {
                                    arrCountFilter && arrCountFilter[2] > 0 && (
                                        <div onClick={() => filterChangeFunc(2)} className={selectFilterState == 2 ? "select filterOptionsItem filterOptionsItem2" : "filterOptionsItem filterOptionsItem2"}>Vence Hoy({arrCountFilter[2]})</div>
                                    )
                                }
                                {
                                    arrCountFilter && arrCountFilter[3] > 0 && (
                                        <div onClick={() => filterChangeFunc(3)} className={selectFilterState == 3 ? "select filterOptionsItem filterOptionsItem3" : "filterOptionsItem filterOptionsItem3"}>Morosos({arrCountFilter[3]})</div>
                                    )
                                }
                                {
                                    arrCountFilter && arrCountFilter[4] > 0 && (
                                        <div onClick={() => filterChangeFunc(4)} className={selectFilterState == 4 ? "select filterOptionsItem filterOptionsItem4" : "filterOptionsItem filterOptionsItem4"}>Finalizados({arrCountFilter[4]})</div>
                                    )
                                }
                                {
                                    arrCountFilter && arrCountFilter[0] > 0 && (
                                        <div onClick={() => filterChangeFunc(0)} className={selectFilterState == 0 ? "select filterOptionsItem filterOptionsItem5" : "filterOptionsItem filterOptionsItem5"}>All({arrCountFilter[0]})</div>
                                    )
                                }
                                {
                                    arrCountFilter && (
                                        <div onClick={() => filterChangeFunc(8)} className={selectFilterState == 8 ? "select filterOptionsItem filterOptionsItem8" : "filterOptionsItem filterOptionsItem8"}>List All({arrCountFilter[0]})</div>
                                    )
                                }
                            </div>


                            {
                                showPagination && (
                                    <div className="boxPagination boxPaginationTop">
                                        <ResponsivePagination
                                            current={selectPagination}
                                            total={numPages}
                                            onPageChange={getDataOfPagination}
                                        />
                                    </div>
                                )
                            }
                        </div>

                        <div className="parentTable fmUxTableWrap">
                            <table className="fmUxTable">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Estado</th>
                                        <th>Inscripción</th>
                                        {/* <th>Vencimiento</th> */}
                                        <th>Total FM</th>
                                        <th>Fuente</th>
                                        <th>Días Vencidos</th>
                                        <th>Total cuotas</th>
                                        <th>Cuota FM</th>
                                        <th>Monto Cuota Total</th>
                                        <th>Cuotas Pagadas</th>
                                        <th>Cuotas Vencidas</th>
                                        <th>Monto Vencido</th>
                                        <th>Sede</th>
                                        <th>Seller</th>
                                        <th>DNI</th>
                                        <th>Nombre Cliente</th>
                                        <th>Celular</th>
                                        <th>Nombre de Equipo</th>
                                        <th>Estado de Inscripción</th>
                                        <th>ACPD</th>
                                        <th>Ver</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        listCredits && listCredits.map((item, index, arr) => {
                                            // === Cálculo correcto de cuotas/días vencidos (usa primera impaga) ===
                                            const schedule = JSON.parse(item.daysPayment || '[]');
                                            const firstUnpaid = schedule.find(p => Number(p.state) === 0);
                                            const duesPaid = schedule.filter(p => Number(p.state) === 1);

                                            // cuotas impagas cuya fecha ya pasó
                                            const today = moment().startOf('day');
                                            const pastDueInstalments = schedule.filter(p => {
                                                if (Number(p.state) !== 0) return false;
                                                return today.isAfter(moment(p.date, 'DD/MM/YYYY'), 'day');
                                            });

                                            // fecha ISO de la primera impaga (para estado)
                                            let constructDate = null; // YYYY-MM-DD
                                            let daysInArrears = 0;
                                            if (firstUnpaid?.date) {
                                                constructDate = moment(firstUnpaid.date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                                const firstDue = moment(constructDate, 'YYYY-MM-DD').startOf('day');
                                                if (today.isAfter(firstDue)) {
                                                    daysInArrears = today.diff(firstDue, 'days');
                                                }
                                            }

                                            const mm = moment().format().split('T');
                                            const sumCuotaTotalFormat = Number(item.amountSource) + Number(item.fee)
                                            const sumCuotaTotal = sumCuotaTotalFormat.toFixed(2)

                                            return <tr key={index}>
                                                <td>{item.id}</td>
                                                <td className="tdStateDevice">
                                                    {
                                                        constructDate == null ?
                                                            <span className="cuatro blueState">Finalizado</span>
                                                            : mm[0] === constructDate ?
                                                                <span className="dos orangeState">Vence Hoy</span>
                                                                : moment(mm[0]).isBefore(moment(constructDate, 'YYYY-MM-DD')) ?
                                                                    <span className="uno greenState">Activo</span>
                                                                    :
                                                                    <span className="dos redState">Bloqueado</span>
                                                    }
                                                </td>
                                                <td>{item.contractDate}</td>
                                                <td>S/ {Number(item.amount).toFixed(2)}</td>
                                                <td><span className={`fmUxSource fmUxSource--${String(item.source || 'unknown')}`}>{getFmSourceLabel(item.source)}</span></td>
                                                <td>{daysInArrears === 1 ? '1 Dia' : `${daysInArrears} Dias`}</td>
                                                <td>{schedule.length}</td>
                                                <td>S/ {parseFloat(item.fee).toFixed(2)}</td>
                                                <td>S/ {sumCuotaTotal}</td>
                                                <td>{duesPaid.length}</td>
                                                <td>{pastDueInstalments.length}</td>
                                                <td>S/. {parseFloat(pastDueInstalments.length * item.fee).toFixed(2)}</td>
                                                <td>{item.sedeName}</td>
                                                <td className="sellerName">{item.userName + ' ' + item.paternalSur}</td>
                                                <td>{item.dni}</td>
                                                <td>{item.name + ' ' + item.lastName}</td>
                                                <td>{item.phoneNumber}</td>
                                                <td>{item.phoneName}</td>
                                                <td>{item.paymentState == 1 ? 'Activo' : 'Finalizado'}</td>
                                                <td>
                                                    {item.paymentState == 1 && (
                                                        <a target="_blank" download={true} href={process.env.REACT_APP_API + '/data-files-or/' + item.uploadName + '/' + 'acta-de-compromiso-de-pago-de-deuda.pdf'}><ImFilePdf /></a>
                                                    )}
                                                </td>
                                                <td><Link className="aview" to={'../fm/' + item.linkNumber}><ImEye /></Link></td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>

                        {
                            showPagination && (
                                <div className="boxPagination">
                                    <ResponsivePagination
                                        current={selectPagination}
                                        total={numPages}
                                        onPageChange={getDataOfPagination}
                                    />
                                </div>
                            )
                        }
                    </div>
                </div>
            </section>
            <Footer />

            {/* {
                showPopupAdd && (
                    <div className="fpPopup">
                        <div className="fpPopupCover"></div>
                        <div className="fpClosePopupFM" onClick={closeFmPopup}><ImCross></ImCross></div>
                        <div className="fpPopupInt">
                            <div className="fpPopupIntCenter">
                                <div className="fpPopupScroll">

                                    <div className="parentFormFm fadeInZoom">
                                        <h2>Financiamiento Mixto</h2>
                                        <form id="formFm" ref={formFmRef}>

                                            <div className="wrapperLabelTwo">
                                                <div className="wrapperLabel">
                                                    <label htmlFor="source">Fuente</label>
                                                    <select
                                                        id="source"
                                                        ref={sourceRef}
                                                        onChange={changeSource}
                                                    >
                                                        <option value={1}>Payjoy</option>
                                                        <option value={2}>MovilesPay</option>
                                                        <option value={3}>Efectiva</option>
                                                        <option value={4}>CrediSmart</option>
                                                        <option value={5}>Alo Credit</option>
                                                    </select>
                                                </div>

                                                <div className="wrapperLabel formFmComplement">
                                                    <label htmlFor="amountSource">Cuota {source}</label>
                                                    <span>S/</span>
                                                    <input
                                                        type="number"
                                                        id="amountSource"
                                                        value={amountSource}
                                                        onInput={doDecimal}
                                                        ref={amountSourceRef}
                                                    />
                                                </div>
                                            </div>

                                            <div className="wrapperLabelTwo wrapperLabelTwoR">
                                                <div className="wrapperLabel">
                                                    <label htmlFor="fullName">Nombre Completo</label>
                                                    <input
                                                        type="text"
                                                        id="fullName"
                                                        onInput={handleFullNameInput}
                                                        ref={fullNameRef}
                                                    />
                                                </div>
                                                <div className="wrapperLabel">
                                                    <label htmlFor="lastName">Apellidos</label>
                                                    <input
                                                        type="text"
                                                        id="lastName"
                                                        onInput={handleLastNameInput}
                                                        ref={lastNameRef}
                                                    />
                                                </div>
                                            </div>

                                            <div className="wrapperLabelTwo wrapperLabelTwoR">
                                                <div className="wrapperLabel">
                                                    <label htmlFor="dni">DNI</label>
                                                    <input
                                                        type="number"
                                                        id="dni"
                                                        onInput={handleDniInput}
                                                        ref={dniRef}
                                                    />
                                                </div>

                                                <div className="wrapperLabel formFmComplement">
                                                    <label htmlFor="phoneName">Número de celular</label>
                                                    <span>+51</span>
                                                    <input
                                                        type="tel"
                                                        id="phoneName"
                                                        onInput={handlePhoneInput}
                                                        ref={phoneNumberRef}
                                                    />
                                                </div>
                                            </div>


                                            <div className="wrapperLabel formFmComplement">
                                                <label htmlFor="email">Email</label>
                                                <span>@</span>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    onInput={handleEmailInput}
                                                    ref={emailRef}
                                                />
                                            </div>

                                            <div className="wrapperLabel">
                                                <label htmlFor="adressName">Domicilio</label>
                                                <input
                                                    type="text"
                                                    id="adressName"
                                                    onInput={handleAddressInput}
                                                    ref={addressNameRef}
                                                />
                                            </div>

                                            <div className="wrapperLabel">
                                                <label htmlFor="paymentFrequency">Frecuencia de pago</label>
                                                <select id="paymentFrequency" ref={pfRef} onChange={pfChange}>
                                                    {
                                                        paymentFrequency.map((item, index) => {
                                                            return <option key={index} value={index + 1}> {item} </option>
                                                        })
                                                    }
                                                </select>
                                            </div>

                                            <div className="wrapperLabelTwo">
                                                <div className="wrapperLabel formFmComplement">
                                                    <label htmlFor="amountFM">Monto FM</label>
                                                    <span>S/</span>
                                                    <input
                                                        type="number"
                                                        id="amountFM"
                                                        onInput={doDecimal}
                                                        onKeyUp={calculateFee}
                                                        ref={amountFMRef}
                                                    />
                                                </div>
                                                <div className="wrapperLabel">
                                                    <label htmlFor="numfee">Cuotas A dividir</label>
                                                    <select
                                                        id="numfee"
                                                        ref={numFeeRef}
                                                        onChange={calculateFee}
                                                    >
                                                        {
                                                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, n) => <option key={i} value={i}>{i > 1 ? i + ' ' + ordinalsTime[parseInt(pf) - 1].plural : i + ' ' + ordinalsTime[parseInt(pf) - 1].singular}</option>)
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="wrapperLabelTwo">
                                                <div className="wrapperLabel formFmComplement">
                                                    <label htmlFor="fee">Monto Cuota</label>
                                                    <span>S/</span>
                                                    <input id="fee" value={amountFee} ref={feeRef} readOnly={true} />
                                                </div>
                                                <div className="wrapperLabel">
                                                    <label htmlFor="countFeePay">Cuotas Pagadas</label>
                                                    <select id="countFeePay" ref={countFeePayRef}>
                                                        {
                                                            countFeePayArr.map((i, n) => <option key={i} value={i}>{i}</option>)
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="wrapperLabel">
                                                <label htmlFor="phone">Equipo FM</label>
                                                <Select
                                                    value={listPhones.filter(item => item.value === phoneName)}
                                                    placeholder={'Seleccióne un Equipo'}
                                                    onChange={listPhoneChange}
                                                    options={listPhones}
                                                    className="selectForm formItem selectPhone"
                                                    name="phone"
                                                    id="phone"
                                                    ref={modelPhoneRef}
                                                />
                                            </div>

                                            <div className="wrapperLabel">
                                                <label htmlFor="imei">IMEI</label>
                                                <input
                                                    type="number"
                                                    id="imei"
                                                    onInput={handleImeiInput}
                                                    ref={imeiRef}
                                                />
                                            </div>

                                            <div className="wrapperLabel">
                                                <label htmlFor="dateRegister">Fecha de Registro</label>
                                                <input
                                                    readOnly
                                                    ref={calendarInputRef}
                                                    value={formatDate(startDate)}
                                                    className="flatpickr-input-centered"
                                                />
                                            </div>

                                            <div className="wrapperLabel">
                                                <label htmlFor="sede">Sede</label>
                                                <select id="sede" ref={sedeRef}>
                                                    {
                                                        sedesArr.map((item, index) => {
                                                            return <option key={index} value={index + 1}> {item} </option>
                                                        })
                                                    }
                                                </select>
                                            </div>

                                            <div className="wrapperLabelTwo wrapperLabelTwoR">
                                                <div className="wrapperImages">
                                                    <label htmlFor="dniFront">
                                                        <span>DNI Frontal</span>
                                                        <img
                                                            src={imgPreviewFront ? imgPreviewFront : placeHolderFileImage + 'DNI%20FRONTAL'}
                                                            alt="DNI FRONT"
                                                        />
                                                    </label>
                                                    <input
                                                        type="file"
                                                        accept=".jpg,.JPG,.webp,.WEBP,.jpeg,.JPEG,.png,.PNG,.jfif,.JFIF"
                                                        id="dniFront"
                                                        ref={dniFrontRef}
                                                        onChange={drivePreviewFront}
                                                    />
                                                </div>
                                                <div className="wrapperImages">
                                                    <label htmlFor="dniBack">
                                                        <span>DNI Trasero</span>
                                                        <img
                                                            src={imgPreviewBack ? imgPreviewBack : placeHolderFileImage + 'DNI%20TRASERO'}
                                                            alt="DNI BACK"
                                                        />
                                                    </label>
                                                    <input
                                                        type="file"
                                                        accept=".jpg,.JPG,.webp,.WEBP,.jpeg,.JPEG,.png,.PNG,.jfif,.JFIF"
                                                        id="dniBack"
                                                        ref={dniBackRef}
                                                        onChange={drivePreviewBack}
                                                    />
                                                </div>
                                            </div>

                                            <button type="button" onClick={sendFmData}>Agregar FM</button>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                )
            } */}

        </div>
    )
}

export default FmPage
